import React from "react";
import { Box, Typography, Button } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export default function NotFoundPage() {
  return (
    <>
      {/* Inline CSS */}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }

        @keyframes pulseGlow {
          0% { opacity: .5; transform: scale(1); }
          50% { opacity: .9; transform: scale(1.15); }
          100% { opacity: .5; transform: scale(1); }
        }
      `}</style>

      {/* Main Container */}
      <Box
        sx={{
            mt:8,
          height: "100vh",
          width: "100%",
          background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Glowing Background Circles */}
        <Box
          sx={{
            position: "absolute",
            width: 250,
            height: 250,
            borderRadius: "50%",
            background: "rgba(0, 188, 212, 0.35)",
            filter: "blur(80px)",
            top: "15%",
            left: "20%",
            animation: "pulseGlow 6s infinite",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: 230,
            height: 230,
            borderRadius: "50%",
            background: "rgba(255, 64, 129, 0.35)",
            filter: "blur(80px)",
            bottom: "15%",
            right: "15%",
            animation: "pulseGlow 7s infinite",
          }}
        />

        {/* Card */}
        <Box
          sx={{
            background: "rgba(255,255,255,0.1)",
            padding: "60px 70px",
            borderRadius: "20px",
            backdropFilter: "blur(15px)",
            border: "1px solid rgba(255,255,255,0.25)",
            textAlign: "center",
            zIndex: 2,
          }}
        >
          <ErrorOutlineRoundedIcon
            sx={{
              fontSize: "80px",
              color: "#fff",
              marginBottom: "10px",
              animation: "float 3s infinite",
            }}
          />

          <Typography
            variant="h1"
            sx={{
              fontWeight: 900,
              fontSize: "5rem",
              color: "#fff",
              textShadow: "0px 0px 25px rgba(255,255,255,0.4)",
              animation: "float 4s infinite",
            }}
          >
            404
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.9)",
              fontSize: "22px",
              marginTop: "10px",
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.7)",
              marginTop: "8px",
              marginBottom: "28px",
            }}
          >
            The page you’re looking for doesn’t exist or has been moved.
          </Typography>

          <Button
            variant="contained"
            onClick={() => (window.location.href = "/")}
            startIcon={<HomeRoundedIcon />}
            sx={{
              background: "linear-gradient(90deg, #00bcd4, #3f51b5)",
              padding: "10px 25px",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              color: "#fff",
              fontSize: "16px",
            }}
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </>
  );
}
